﻿import { response_method_payment_profile } from "./response_method_payment_profile";


export class response_method {
    public payment_processor: string | null = null;
    public payment_method   : string | null = null;
    public accepts          : string[] | null = [];
    public payment_reference: string | null = null;
    public form_iframe      : string | null = null;
    public form_post        : string | null = null;
    public script_library   : string | null = null;
    public data_payload     : string | null = null;
    public payment_link_url : string | null = null;
    public payment_profiles : response_method_payment_profile[] | null = [];
}